module.exports = __webpack_public_path__ + "img/product-image.a10ab93c.png";